import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import React, { useState } from 'react';
import { ButtonBase, Stack, Tooltip } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { Editor } from 'react-draft-wysiwyg';
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertToRaw,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';

interface EditableTextWithDraftEditorProps {
  label: string;
  onSubmit: (editText: string) => void;
  editorStyles?: React.CSSProperties;
}

const fieldStyles: React.CSSProperties = {
  border: '1px solid lightgray',
  borderRadius: '4px',
  padding: '15px',
};

const EditableTextWithDraftEditor: React.FC<EditableTextWithDraftEditorProps> = ({
  label,
  onSubmit,
  editorStyles = {},
}) => {
  // State
  const [editText, setEditText] = useState(EditorState.createEmpty());
  const [editMode, setEditMode] = useState(false);

  const openEditMode = () => {
    setEditMode(true);

    const _blocksFromHTML = convertFromHTML(label);
    const _editorState = ContentState.createFromBlockArray(
      _blocksFromHTML.contentBlocks,
      _blocksFromHTML.entityMap
    );

    setEditText(EditorState.createWithContent(_editorState));
  };

  const closeEditMode = () => {
    setEditMode(false);
    setEditText(EditorState.createEmpty());
  };

  const handleEditorChange = (value) => {
    setEditText(value);
  };

  const handleSubmit = () => {
    const _converted = draftToHtml(convertToRaw(editText.getCurrentContent()));

    if (_converted !== label) {
      onSubmit(_converted);
    }

    closeEditMode();
  };

  if (editMode) {
    return (
      <Editor
        editorState={editText}
        editorStyle={{ ...fieldStyles, ...editorStyles }}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        onEditorStateChange={handleEditorChange}
        placeholder="Enter Here..."
        onBlur={handleSubmit}
      />
    );
  }

  return (
    <Stack direction="row">
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: label }} />
      &nbsp;
      <Tooltip title="Edit" placement="top">
        <ButtonBase onClick={openEditMode}>
          <EditIcon fontSize="small" />
        </ButtonBase>
      </Tooltip>
    </Stack>
  );
};

export default EditableTextWithDraftEditor;
